import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type CmaConfigType = {
  m2mConfig: CmaConfigM2MType;
  webTokenAuthConfig: CmaConfigWebTokenAuthType;
};

export type CmaConfigM2MType = {
  baseUrl: string;
  consumer: string;
  tokenHandler: {
    grantType: string;
    url: string;
    scope: string;
    secretNames: {
      clientId: string;
      clientSecret: string;
    };
  };
};

export type CmaConfigWebTokenAuthType = {
  baseUrl: string;
  consumer: string;
  secretNames: {
    clientId: string;
  };
};

export type AllowedIntegrityCode = Static<typeof AllowedIntegrityCodeSchema>;
export const AllowedIntegrityCodeSchema = Type.Object({
  // Same names as in customer master
  integrityType: Type.Union([Type.Literal('AllowPersonalEmail')]),
});
